import './operations.scss'
import templateUrl from './operations.html'

/**
 * TMR Operations base route.
 *
 * To create a new Operation, the only thing needed is a route with component
 * with a name that begins with `operations.`
 *
 * @example
 * export const route = {
 *   name: 'operations.myOperation',
 *   ...
 * };
 *
 * @namespace routes.Operations
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations',
  label: 'OPERATIONS.TITLE',
  url: '/operations',
  resolve: {
    operations: resolveOperations,
  },
  component: 'tmrOperations',
  mainMenu: true,
  accessControl: [],
  weight: 1,
  frontPage: true,
  icon: 'o-grid-layout-1',
}

/**
 * Resolves operations (routes with app.operations state as parent).
 *
 * @ignore
 * @todo If no operations, abort transition
 */
function resolveOperations($state, UserStorage) {
  'ngInject'
  return Object.values($state.router.stateRegistry.states).filter(
    state =>
      state.parent &&
      state.parent.name == 'app.operations' &&
      UserStorage.access(state)
  )
}

/**
 * Operations component
 *
 * @type {ngComponent}
 * @todo document
 */
export const tmrOperations = {
  ngType: 'component',
  templateUrl,
  bindings: {
    operations: '<',
  },
}

/**
 * Operations state Run phase.
 *
 * @type {ngRun}
 */
function tmrOperationsRun($state, $transitions, TmrNoActiveWorkstationError) {
  'ngInject'
  // If user tried to access an app.operations.* state without an active workstation,
  // show an error state.
  $transitions.onError({ to: 'app.operations.**' }, onError)

  function onError(transition) {
    if (transition.error().detail instanceof TmrNoActiveWorkstationError)
      $state.go(
        'app.workstationError',
        { transitionState: transition.to().name },
        { reload: true }
      )
  }
}

export { tmrOperationsRun as run }
